import { render, staticRenderFns } from "./ConstructorQuestions.vue?vue&type=template&id=542842b9&"
import script from "./ConstructorQuestions.vue?vue&type=script&lang=js&"
export * from "./ConstructorQuestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports